import * as Types from '../../types/bff/gql-schema';

import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { gqlFetcher } from '@/utils/fetcher';

export const SearchDoctorsByUserDocument = `
    query SearchDoctorsByUser($request: DoctorSearchByUserRequestInput!) {
  searchDoctorsByUser(request: $request) {
    totalCount
    items {
      createdAt
      hospitalName
      id
      publicId
      isAffiliated
      medicineType
      name
      profileUrl
      medicineType
      professionalDepartment {
        name
      }
      readyForVideoCall
      reviewAverageRating
      reviewCount
      bookingInfo {
        bookingAvailability
        isBookable
        todayBookable
        todayCutoffTime
        todayKickoffTime
        todaySchedule
        tomorrowBookable
        tomorrowCutoffTime
        tomorrowKickoffTime
        tomorrowSchedule
      }
    }
  }
}
    `;
export const useSearchDoctorsByUserQuery = <
      TData = Types.SearchDoctorsByUserQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.SearchDoctorsByUserQueryVariables,
      options?: UseQueryOptions<Types.SearchDoctorsByUserQuery, TError, TData>,
    ) =>
    useQuery<Types.SearchDoctorsByUserQuery, TError, TData>(
      ['SearchDoctorsByUser', variables],
      gqlFetcher<Types.SearchDoctorsByUserQuery, Types.SearchDoctorsByUserQueryVariables>(SearchDoctorsByUserDocument, 'SearchDoctorsByUser', variables),
      options
    );

useSearchDoctorsByUserQuery.getKey = (variables: Types.SearchDoctorsByUserQueryVariables) => ['SearchDoctorsByUser', variables];
;

useSearchDoctorsByUserQuery.fetcher = (variables: Types.SearchDoctorsByUserQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.SearchDoctorsByUserQuery, Types.SearchDoctorsByUserQueryVariables>(SearchDoctorsByUserDocument, 'SearchDoctorsByUser', variables, options);
export const SearchDoctorsByTimeSlotDocument = `
    query SearchDoctorsByTimeSlot($request: TimeSlotBasedDoctorSearchMutationRequestInput!) {
  searchDoctorsByTimeSlot(request: $request) {
    totalCount
    items {
      createdAt
      hospitalName
      id
      publicId
      isAffiliated
      medicineType
      name
      profileUrl
      medicineType
      professionalDepartment {
        name
      }
      readyForVideoCall
      reviewAverageRating
      reviewCount
    }
  }
}
    `;
export const useSearchDoctorsByTimeSlotQuery = <
      TData = Types.SearchDoctorsByTimeSlotQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.SearchDoctorsByTimeSlotQueryVariables,
      options?: UseQueryOptions<Types.SearchDoctorsByTimeSlotQuery, TError, TData>,
    ) =>
    useQuery<Types.SearchDoctorsByTimeSlotQuery, TError, TData>(
      ['SearchDoctorsByTimeSlot', variables],
      gqlFetcher<Types.SearchDoctorsByTimeSlotQuery, Types.SearchDoctorsByTimeSlotQueryVariables>(SearchDoctorsByTimeSlotDocument, 'SearchDoctorsByTimeSlot', variables),
      options
    );

useSearchDoctorsByTimeSlotQuery.getKey = (variables: Types.SearchDoctorsByTimeSlotQueryVariables) => ['SearchDoctorsByTimeSlot', variables];
;

useSearchDoctorsByTimeSlotQuery.fetcher = (variables: Types.SearchDoctorsByTimeSlotQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.SearchDoctorsByTimeSlotQuery, Types.SearchDoctorsByTimeSlotQueryVariables>(SearchDoctorsByTimeSlotDocument, 'SearchDoctorsByTimeSlot', variables, options);
export const GetDiagnosisCategoriesV2Document = `
    query GetDiagnosisCategoriesV2($contactType: DiagnosisContactType!) {
  getDiagnosisCategoriesV2(contactType: $contactType) {
    popularDepartmentCategories {
      id
      name
    }
    departmentCategories {
      id
      name
      iconUrl
      description
    }
    popularTreatmentCategories {
      id
      name
    }
    treatmentCategories {
      id
      name
      iconUrl
      items {
        id
        name
      }
    }
  }
}
    `;
export const useGetDiagnosisCategoriesV2Query = <
      TData = Types.GetDiagnosisCategoriesV2Query,
      TError = Types.GraphqlError
    >(
      variables: Types.GetDiagnosisCategoriesV2QueryVariables,
      options?: UseQueryOptions<Types.GetDiagnosisCategoriesV2Query, TError, TData>,
    ) =>
    useQuery<Types.GetDiagnosisCategoriesV2Query, TError, TData>(
      ['GetDiagnosisCategoriesV2', variables],
      gqlFetcher<Types.GetDiagnosisCategoriesV2Query, Types.GetDiagnosisCategoriesV2QueryVariables>(GetDiagnosisCategoriesV2Document, 'GetDiagnosisCategoriesV2', variables),
      options
    );

useGetDiagnosisCategoriesV2Query.getKey = (variables: Types.GetDiagnosisCategoriesV2QueryVariables) => ['GetDiagnosisCategoriesV2', variables];
;

useGetDiagnosisCategoriesV2Query.fetcher = (variables: Types.GetDiagnosisCategoriesV2QueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.GetDiagnosisCategoriesV2Query, Types.GetDiagnosisCategoriesV2QueryVariables>(GetDiagnosisCategoriesV2Document, 'GetDiagnosisCategoriesV2', variables, options);